// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes tooltipTop {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-100% - 8px));
  }
  to {
    opacity: 1;
    transform: translate(-50%, calc(-100% - 8px));
  }
}
@keyframes tooltipBottom {
  from {
    opacity: 0;
    transform: translate(-50%, 8px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 8px);
  }
}
@keyframes tooltipLeft {
  from {
    opacity: 0;
    transform: translate(calc(-100% - 8px), -50%);
  }
  to {
    opacity: 1;
    transform: translate(calc(-100% - 8px), -50%);
  }
}
@keyframes tooltipRight {
  from {
    opacity: 0;
    transform: translate(8px, -50%);
  }
  to {
    opacity: 1;
    transform: translate(8px, -50%);
  }
}
.RCTooltip {
  position: absolute;
  z-index: 9999;
  background: var(--base_color1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 14px;
  border-radius: 4px;
  pointer-events: none;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  max-width: 225px;
  font-size: 13px;
  color: var(--color_neutral_0);
  text-align: center;
  word-break: break-word;
  opacity: 0;
  visibility: hidden;
}
.RCTooltip.visible {
  visibility: visible;
  pointer-events: auto;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.74, -0.03, 0.05, 1.24);
}
.RCTooltip::before {
  content: "";
  display: block;
  position: absolute;
  z-index: 9999;
  width: 0;
  height: 0;
  pointer-events: none;
  border: 6px solid transparent;
}
.RCTooltip.top, .RCTooltip.tooltippedN {
  transform-origin: 50% 100%;
}
.RCTooltip.top.visible, .RCTooltip.tooltippedN.visible {
  animation-name: tooltipTop;
}
.RCTooltip.top::before, .RCTooltip.tooltippedN::before {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-top-color: var(--base_color1);
}
.RCTooltip.bottom, .RCTooltip.tooltippedS {
  transform-origin: 50% 0%;
}
.RCTooltip.bottom.visible, .RCTooltip.tooltippedS.visible {
  animation-name: tooltipBottom;
}
.RCTooltip.bottom::before, .RCTooltip.tooltippedS::before {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-bottom-color: var(--base_color1);
}
.RCTooltip.left, .RCTooltip.tooltippedW {
  transform-origin: 100% 50%;
}
.RCTooltip.left.visible, .RCTooltip.tooltippedW.visible {
  animation-name: tooltipLeft;
}
.RCTooltip.left::before, .RCTooltip.tooltippedW::before {
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  border-left-color: var(--base_color1);
}
.RCTooltip.right, .RCTooltip.tooltippedE {
  transform-origin: 0% 50%;
}
.RCTooltip.right.visible, .RCTooltip.tooltippedE.visible {
  animation-name: tooltipRight;
}
.RCTooltip.right::before, .RCTooltip.tooltippedE::before {
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  border-right-color: var(--base_color1);
}`, "",{"version":3,"sources":["webpack://./src/components/RCTooltip/styles.scss"],"names":[],"mappings":"AAAA;EACE;IACE,UAAA;IACA,6CAAA;EACF;EAEA;IACE,UAAA;IACA,6CAAA;EAAF;AACF;AAGA;EACE;IACE,UAAA;IACA,+BAAA;EADF;EAIA;IACE,UAAA;IACA,+BAAA;EAFF;AACF;AAKA;EACE;IACE,UAAA;IACA,6CAAA;EAHF;EAMA;IACE,UAAA;IACA,6CAAA;EAJF;AACF;AAOA;EACE;IACE,UAAA;IACA,+BAAA;EALF;EAQA;IACE,UAAA;IACA,+BAAA;EANF;AACF;AASA;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,yCAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EAEA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,sBAAA;EAEA,UAAA;EACA,kBAAA;AATF;AAWE;EACE,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,6BAAA;EACA,gEAAA;AATJ;AAYE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,6BAAA;AAVJ;AAaE;EAEE,0BAAA;AAZJ;AAcI;EACE,0BAAA;AAZN;AAeI;EACE,SAAA;EACA,SAAA;EACA,2BAAA;EACA,oCAAA;AAbN;AAiBE;EAEE,wBAAA;AAhBJ;AAkBI;EACE,6BAAA;AAhBN;AAmBI;EACE,YAAA;EACA,SAAA;EACA,2BAAA;EACA,uCAAA;AAjBN;AAqBE;EAEE,0BAAA;AApBJ;AAsBI;EACE,2BAAA;AApBN;AAuBI;EACE,QAAA;EACA,UAAA;EACA,2BAAA;EACA,qCAAA;AArBN;AAyBE;EAEE,wBAAA;AAxBJ;AA0BI;EACE,4BAAA;AAxBN;AA2BI;EACE,QAAA;EACA,WAAA;EACA,2BAAA;EACA,sCAAA;AAzBN","sourcesContent":["@keyframes tooltipTop {\n  from {\n    opacity: 0;\n    transform: translate(-50%, calc(-100% - 8px));\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, calc(-100% - 8px));\n  }\n}\n\n@keyframes tooltipBottom {\n  from {\n    opacity: 0;\n    transform: translate(-50%, 8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, 8px);\n  }\n}\n\n@keyframes tooltipLeft {\n  from {\n    opacity: 0;\n    transform: translate(calc(-100% - 8px), -50%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(calc(-100% - 8px), -50%);\n  }\n}\n\n@keyframes tooltipRight {\n  from {\n    opacity: 0;\n    transform: translate(8px, -50%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(8px, -50%);\n  }\n}\n\n.RCTooltip {\n  position: absolute;\n  z-index: 9999;\n  background: var(--base_color1);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  padding: 14px;\n  border-radius: 4px;\n  pointer-events: none;\n  width: max-content;\n  max-width: 225px;\n\n  font-size: 13px;\n  color: var(--color_neutral_0);\n  text-align: center;\n  word-break: break-word;\n\n  opacity: 0;\n  visibility: hidden;\n\n  &.visible {\n    visibility: visible;\n    pointer-events: auto;\n    animation-duration: 0.3s;\n    animation-fill-mode: forwards;\n    animation-timing-function: cubic-bezier(0.74, -0.03, 0.05, 1.24);\n  }\n\n  &::before {\n    content: '';\n    display: block;\n    position: absolute;\n    z-index: 9999;\n    width: 0;\n    height: 0;\n    pointer-events: none;\n    border: 6px solid transparent;\n  }\n\n  &.top,\n  &.tooltippedN {\n    transform-origin: 50% 100%;\n\n    &.visible {\n      animation-name: tooltipTop;\n    }\n\n    &::before {\n      top: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n      border-top-color: var(--base_color1);\n    }\n  }\n\n  &.bottom,\n  &.tooltippedS {\n    transform-origin: 50% 0%;\n\n    &.visible {\n      animation-name: tooltipBottom;\n    }\n\n    &::before {\n      bottom: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n      border-bottom-color: var(--base_color1);\n    }\n  }\n\n  &.left,\n  &.tooltippedW {\n    transform-origin: 100% 50%;\n\n    &.visible {\n      animation-name: tooltipLeft;\n    }\n\n    &::before {\n      top: 50%;\n      left: 100%;\n      transform: translateY(-50%);\n      border-left-color: var(--base_color1);\n    }\n  }\n\n  &.right,\n  &.tooltippedE {\n    transform-origin: 0% 50%;\n\n    &.visible {\n      animation-name: tooltipRight;\n    }\n\n    &::before {\n      top: 50%;\n      right: 100%;\n      transform: translateY(-50%);\n      border-right-color: var(--base_color1);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
